import React from 'react';

const viCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <circle cx="12" cy="12" r="12" fill="none" fillRule="evenodd" stroke="currentColor" />
  </svg>
);

export default viCircle;
